/***
 * 验证规则配置
 * rule.validator
 * @method rule.validator 验证方法.
 * @param {any} value 输入的值.
 * @param {String} name 验证控件的name属性.
 * @param {String} arg 规则的参数，如'maxlength:256'的arg的值就是'256'.
 * rule.getMessage 
 * @method rule.getMessage 获取提示信息的方法.
 * @param {any} value 输入的值.
 * @param {String} name 验证控件的name属性.
 * @param {String} arg 规则的参数，如'maxlength:256'的arg的值就是'256'.
 */

/***
 * IP验证
 * @param {String} str 输入.
 * @param {Number} versionNumber IP版本.
 * @return {Boolean} 验证结果.
 */
const isIP = function (str: string, versionNumber?: number) : boolean {
    let ipv4Maybe: any = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    let ipv6Block: any = /^[0-9A-F]{1,4}$/i;
    let version: any = String(versionNumber);

    if (!versionNumber) {
        return isIP(str, 4) || isIP(str, 6);
    } else if (version === '4') {
        if (!ipv4Maybe.test(str)) {
            return false;
        }
        let parts: string[] = str.split('.').sort(function (a: any, b: any) {
            return a - b;
        });
        return Number(parts[3]) <= 255;
    } else if (version === '6') {
        let blocks: string[] = str.split(':');
        let foundOmissionBlock: any = false; // marker to indicate ::
        // At least some OS accept the last 32 bits of an IPv6 address
        // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
        // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
        // and '::a.b.c.d' is deprecated, but also valid.

        let foundIPv4TransitionBlock: boolean = isIP(blocks[blocks.length - 1], 4);
        let expectedNumberOfBlocks: number = foundIPv4TransitionBlock ? 7 : 8;

        if (blocks.length > expectedNumberOfBlocks) {
            return false;
        } // initial or final ::


        if (str === '::') {
            return true;
        } else if (str.substr(0, 2) === '::') {
            blocks.shift();
            blocks.shift();
            foundOmissionBlock = true;
        } else if (str.substr(str.length - 2) === '::') {
            blocks.pop();
            blocks.pop();
            foundOmissionBlock = true;
        }

        for (let i = 0; i < blocks.length; ++i) {
            // test for a :: which can not be at the string start/end
            // since those cases have been handled above
            if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
                if (foundOmissionBlock) {
                    return false; // multiple :: in address
                }

                foundOmissionBlock = true;
            //} else if (foundIPv4TransitionBlock && i === blocks.length - 1); else if (!ipv6Block.test(blocks[i])) {
            } else if (!ipv6Block.test(blocks[i])) {
                return false;
            }
        }

        if (foundOmissionBlock) {
            return blocks.length >= 1;
        }

        return blocks.length === expectedNumberOfBlocks;
    }
    return false;
}

const rules: any = {
    passwordLength:{
        validator: (value:any) => value.length > 11 && value.length < 33,
        getMessage: () => "Passwords must be between 12 and 32 characters long.",
    },
    passwordNorm:{
        validator: (value:any) => /^(?![a-zA-Z0-9_]+$)(?![a-zA-Z\W_]+$)(?![a-z0-9\W_]+$)(?![A-Z0-9\W_]+$)/.test(value),
        getMessage: () => "The password must contain at least one uppercase letter, lowercase letter, number and special symbol each.",
    },
    // 必填判断
    required: {
        validator(value: any) {
            return value || value === 0;
        },
        getMessage(value: any, name: string) {
            return name + ' cannot be empty';
        }
    },
    // 必填判断
    multipleRequired: {
        validator(value: any) {
            return value && (value instanceof Array) && value.length > 0;
        },
        getMessage(value: any, name: string) {
            return name + ' cannot be empty';
        }
    },
    // 邮箱
    email: {
        validator(value: any) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        },
        getMessage: () => "Invalid format",
    },
    // 整数
    integer: {
        validator(value: any) {
            return /^-?[0-9]+$/.test( String(value) );
        },
        getMessage: () => "Please enter a correct integer",
    },
    ip: {
        validator(value: any) {
            return isIP(value);
        },
        getMessage: () => "Please enter a correct IP address",
    },
    // 最大值
    max: {
        validator(value: any, name: string, arg: string) {
            let val = Number(value);
            let maxVal = Number(arg);
            return val <= maxVal;
        },
        getMessage(value: any, name: string, arg: string) {
            return name + ' cannot exceed ' + arg;
        }
    },
    // 最大长度
    maxlength: {
        validator(value: any, name: string, arg?: string) {
            arg = arg || '20';
            let val = String(value);
            let len = Number(arg);
            return val.length <= len;
        },
        getMessage(value: any, name: string, arg?: string) {
            arg = arg || '20';
            return name + ' must be no more than ' + arg + ' characters';
        }
    },
    // 最小值
    min: {
        validator(value: any, name: string, arg: string) {
            let val = Number(value);
            let minVal = Number(arg);
            return val >= minVal;
        },
        getMessage(value: any, name: string, arg: string) {
            return name + ' cannot be less than ' + arg;
        }
    },
    // 最小长度
    minlength: {
        validator(value: any, name: string, arg?: string) {
            arg = arg || '5';
            let val = String(value);
            let len = Number(arg);
            return val.length >= len;
        },
        getMessage(value: any, name: string, arg?: string) {
            arg = arg || '5';
            return name + ' should be at least ' + arg + ' characters long';
        }
    },
    // 数字
    number: {
        validator(value: any) {
            if (typeof value !== 'string') {
                value = String(value);
            }
            return /^\d+$/.test(value);
        },
        getMessage: () => "Please enter the correct number",
    }
}
export default rules;